import { StyledCell } from "./Cell.styled";

const Cell = ({ children, red }) => (
  <StyledCell red={red}>{children}</StyledCell>
);

export default Cell;
